<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded">
            <h2 class="panel-header">Invia segnalazione</h2>

            <vue-form-generator :schema="schema" :model="request" :options="formOptions"></vue-form-generator>
        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Api from "../api";
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            "vue-form-generator": VueFormGenerator.component
        },
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            sendRequest() {
                var $scope = this;

                Api.postStation(this.request.email, this.request.message, function(err,res){
                    if(err) {
                        $scope.$swal({
                            title: "Segnalazione non inviata",
                            text: err,
                            icon: "error",
                            button: "Ok",
                        })
                    } else {
                        $scope.$swal({
                            title: "Segnalazione inviata",
                            text: "Grazie della segnalazione, un amministratore provvederà a inserirla quanto prima!",
                            icon: "success",
                            button: "Ok",
                        })
                        serverBus.$emit("closePanel");
                    }
                });
            }
        },
        data() {
            return {
                request: {
                    email: null,
                    message: null
                },
                schema: {
                    fields: [{
                        type: "input",
                        inputType: "email",
                        label: "Email",
                        model: "email",
                        placeholder: "Email",
                        required: true,
                        validator: VueFormGenerator.validators.email
                    },{
                        type: "textArea",
                        label: "Message",
                        model: "message",
                        placeholder: "Message",
                        rows: 5,
                        required: true,
                        validator: VueFormGenerator.validators.string
                    },{
                        type: "submit",
                        buttonText: "Invia",
                        onSubmit: this.sendRequest,
                        validateBeforeSubmit: true
                    }]
                },
                formOptions: {
                    validateAfterChanged: true
                }
            };
        },
        created() {
          serverBus.$emit('pageChanged',{page:'MapAdd'});
        }
    }

</script>
